module.exports = __webpack_public_path__ + "img/airtime.e4a91cc4.svg";